import React from "react";
import Loadable from "react-loadable";

export default (loader, ...props) =>
  Loadable({
    loader,
    loading: ({ error }) => (error ? <div>Error!</div> : <div>Loading...</div>),
    ...props,
  });
